module.exports = __webpack_public_path__ + "img/cut_sc2.a4f4b6d7.png";